import Markdown from 'markdown-to-jsx'
import React from 'react'

import { cn } from '@/legacy-src/lib/utils'

import useFlags from '../../hooks/useFlags'
import { getTranslate } from '../../utilities/i18n'
import TextDivider from '../Divider'
import AppleLoginButton from './appleButton'
import FacebookLoginButton from './facebookButton'
import GoogleLoginButton from './googleLoginButton'

type Props = {
  readonly buttonText: string
  readonly isDiagnosis?: boolean
  readonly emphasizeSocials?: boolean
}

const LoginButtons: React.FC<Props> = ({ buttonText, isDiagnosis = false, emphasizeSocials = false }) => {
  const { t } = getTranslate()
  const { showAppleLogin } = useFlags()

  const displayFbLogin = process.env.NEXT_PUBLIC_FACEBOOK_CLIENT_ID
  const displayGoogleLogin = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID
  const displayAppleButton = showAppleLogin
  const displayLoginButtons = displayFbLogin || displayGoogleLogin

  if (!displayLoginButtons) return null

  return (
    <div className="w-full">
      <div className="mb-6">
        <div className={`-m-1 flex ${emphasizeSocials ? 'flex-col gap-3' : 'flex-wrap'} items-center justify-center`}>
          {displayGoogleLogin && (
            <div className={cn(emphasizeSocials ? 'w-full' : 'p-1')}>
              <GoogleLoginButton isDiagnosis={isDiagnosis} emphasizeSocials={emphasizeSocials}>
                {emphasizeSocials ? t('registration.continueWith.google') : buttonText}
              </GoogleLoginButton>
            </div>
          )}
          {displayFbLogin && (
            <div className={cn(emphasizeSocials ? 'w-full' : 'p-1')}>
              <FacebookLoginButton isDiagnosis={isDiagnosis} emphasizeSocials={emphasizeSocials}>
                {' '}
                {emphasizeSocials ? t('registration.continueWith.facebook') : buttonText}
              </FacebookLoginButton>
            </div>
          )}
          {displayAppleButton && (
            <div className={cn(emphasizeSocials ? 'w-full' : 'p-1')}>
              <AppleLoginButton emphasizeSocials={emphasizeSocials} isDiagnosis={isDiagnosis}>
                {emphasizeSocials ? t('registration.continueWith.apple') : buttonText}
              </AppleLoginButton>
            </div>
          )}
        </div>
        <p className="my-6 text-center text-sm text-text-color">
          <Markdown
            options={{
              overrides: {
                a: (props) => {
                  return <a target="_blank" rel="noopener noreferrer" {...props} />
                },
              },
            }}
          >
            {t(`registration.gdpr`)}
          </Markdown>
        </p>
      </div>
      <TextDivider borderColorClass="border-sand-400">
        <span className="relative top-[-2px] text-sm font-bold">
          {emphasizeSocials ? t('general.or') : t('login.orEmail')}
        </span>
      </TextDivider>
    </div>
  )
}

export default LoginButtons
